import axios from 'axios';

/**
 * Server-side axios instance for backend API calls
 * Uses environment variables for configuration
 */
export const backendApi = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.API_KEY,
  },
  timeout: 10000,
});

/**
 * Client-side axios instance for Next.js API routes
 */
export const clientApi = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

/**
 * Global error handler for client API
 * Redirects to server-status page on critical errors
 */
let isRedirecting = false;

clientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      // Server unavailable or critical errors
      // if (!isRedirecting && (status === 503 || status === 500 || !error.response)) {
      //   isRedirecting = true;
        
      //   // Only redirect in browser environment
      //   if (typeof window !== 'undefined') {
      //     window.location.href = '/server-status';
      //   }
      // }
    }
    
    return Promise.reject(error);
  }
);
